// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"364":"dash-school","800":"dash-rater","933":"dash-admin"}[chunkId] || chunkId) + "." + {"364":"195358c6","800":"a4319224","810":"50e72f3e","874":"b5ac7b46","933":"a29b8545"}[chunkId] + ".js";
};